const isTouchDevice = () => {
  // @ts-expect-error msMaxTouchPoints for IE10 support
  return 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;
};

export { isTouchDevice, isTouchDevice as default };
